import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-pie-chart-sharp",
  "use": "icon-pie-chart-sharp-usage",
  "viewBox": "0 0 512 512",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" class=\"ionicon\" viewBox=\"0 0 512 512\" id=\"icon-pie-chart-sharp\"><title>Pie Chart</title><path d=\"M58 362.09l-6.51-14.59A224 224 0 01256 32h16v234.37z\" /><path d=\"M304 66.46v220.65L94.62 380.78A208.31 208.31 0 00272 480c114.69 0 208-93.31 208-208 0-103.81-76.45-190.1-176-205.54z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol